// extracted by mini-css-extract-plugin
export default {"wrapperHeaderSport":"HeaderSport_wrapperHeaderSport__pgR4N","arrowBack":"HeaderSport_arrowBack__cnCxf","sportName":"HeaderSport_sportName__NPVej"};